import styled, { css } from 'styled-components';

export const Container = styled.div<{ $hasDarkBackground?: boolean }>`
  display: flex;
  padding: ${({ theme }) => theme.spacing(0.5)};

  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme, $hasDarkBackground }) =>
    theme.palette.grey[$hasDarkBackground ? 300 : 100]};
`;

export const Button = styled.button<{
  $rotated?: boolean;
  $disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0;
  padding: 0;
  width: 2.2rem;
  height: 2.2rem;

  border-radius: ${({ theme }) => theme.spacing(2)};
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 200ms;
  -webkit-app-region: no-drag;

  font-size: 1.4rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[700]};

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }

  ${({ $rotated }) =>
    $rotated &&
    css`
      transform: rotate(180deg);
    `};

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
      cursor: default;

      &:hover {
        color: ${({ theme }) => theme.palette.grey[700]};
      }
    `};
`;
